import { Controller } from "@hotwired/stimulus"

// Handles horizontal scrolling for the timeline with scroll indicators
export default class extends Controller {
  static targets = ["scrollContainer", "leftArrow", "rightArrow"]

  connect() {
    this.boundCheckScrollPosition = this.checkScrollPosition.bind(this)
    this.checkScrollPosition()
    this.scrollContainerTarget.addEventListener("scroll", this.boundCheckScrollPosition)

    // Use ResizeObserver to detect container size changes
    this.resizeObserver = new ResizeObserver(() => this.checkScrollPosition())
    this.resizeObserver.observe(this.scrollContainerTarget)
  }

  disconnect() {
    this.scrollContainerTarget.removeEventListener("scroll", this.boundCheckScrollPosition)
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  checkScrollPosition() {
    const container = this.scrollContainerTarget
    const scrollLeft = container.scrollLeft
    const scrollWidth = container.scrollWidth
    const clientWidth = container.clientWidth

    // Show/hide left arrow
    if (this.hasLeftArrowTarget) {
      this.leftArrowTarget.classList.toggle("hidden", scrollLeft <= 0)
    }

    // Show/hide right arrow
    if (this.hasRightArrowTarget) {
      const maxScroll = scrollWidth - clientWidth
      this.rightArrowTarget.classList.toggle("hidden", scrollLeft >= maxScroll - 1)
    }
  }

  scrollLeft() {
    this.scroll(-300)
  }

  scrollRight() {
    this.scroll(300)
  }

  scroll(amount) {
    this.scrollContainerTarget.scrollBy({
      left: amount,
      behavior: "smooth"
    })
  }
}
